import React from 'react';

const card = {
  background: '#1e293b', borderRadius: 10, padding: '14px 18px',
  display: 'flex', flexDirection: 'column', gap: 4,
};

export default function SensorCard({ label, value, unit, color }) {
  return (
    <div style={card}>
      <span style={{ fontSize: 12, color: '#94a3b8' }}>{label}</span>
      <span style={{ fontSize: 22, fontWeight: 700, color: color || '#38bdf8' }}>
        {value !== undefined && value !== null ? Number(value).toFixed(3) : '—'}
        <span style={{ fontSize: 13, fontWeight: 400, marginLeft: 4, color: '#64748b' }}>{unit}</span>
      </span>
    </div>
  );
}
